export default "__VITE_ASSET__CXcZ3e4e__"